<template>
	<div class="about">
		<section class="master">
			<div class="content">
				<div class="summary">
					<component :is="href('/about').content" />
				</div>
			</div>
		</section>
		<section class="story">
			<div class="counter">
				<h3>{{ translation.about.progress }}</h3>
				<strong
					><span v-if="interactionsCompleted == interactionsTotal">{{ translation.about.congratulations }}</span> {{ interactionsCompleted }} {{ translation.about.of }}
					{{ interactionsTotal }} {{ translation.about.completed }}</strong
				>
			</div>
			<progress-bar size="large" :val="progress" bar-color="#80e1bc" />
		</section>
		<section class="interactions">
			<div
				v-for="interaction in href('/interactions/*')"
				:key="interaction.meta.href"
				class="interaction"
			>
				<div
					class="info summary"
					:class="{
						completed: interactions[interaction.meta.interaction].completed,
					}"
				>
					<div class="title">
						<h2 v-html="metatext(interaction.meta.title)"></h2>
						<img :src="interaction.meta.image" />
						<img
							class="mark"
							v-if="interactions[interaction.meta.interaction].completed"
							src="/img/check.svg"
						/>
					</div>
					<div class="description">
						<component :is="interaction.content" />
					</div>
				</div>
				<div
					v-if="interactionComponent(interaction.meta.interaction)"
					class="directions"
					:test="interactionComponent(interaction.meta.interaction)"
				>
					<component
						:showDetails="interactions[interaction.meta.interaction].details"
						:is="interactionComponent(interaction.meta.interaction)"
					/>
					<div class="history content" v-if="interactions[interaction.meta.interaction].events && interactions[interaction.meta.interaction].events.length">
						<h2>{{ translation.about.history }}</h2>
						<whitebox-events
							display="section"
							timeFormat="HH:mm DD.MM.YYYY"
							:showDetails="true"
							:events="interactions[interaction.meta.interaction].events"
							:page="8"
						/>
					</div>
				</div>
			</div>
		</section>
		<section class="leaflet">
			<div class="content">
				<component :is="href('/about/goal').content" />
				<router-link to="/contacts"
					><span><font-awesome-icon icon="long-arrow-alt-right"/></span>&nbsp;{{
						href('/about/goal').meta.action
					}}</router-link
				>
			</div>
		</section>
	</div>
</template>

<style lang="less" scoped>
@import url("~@/assets/views/about.less");
</style>

<script>
import { mapState, mapGetters } from "vuex";

import hreflang from "@/lib/hreflang";
import metatext from "@/lib/metatext";

import ProgressBar from "vue-simple-progress";

let components = {
	ProgressBar,
	CallInteraction: () => import('@/components/interactions/CallInteraction.vue'),
	PassportInteraction: () => import('@/components/interactions/PassportInteraction.vue'),
	EmailInteraction: () => import('@/components/interactions/EmailInteraction.vue'),
	NotificationInteraction: () => import('@/components/interactions/NotificationInteraction.vue'),
	FormsInteraction: () => import('@/components/interactions/FormsInteraction.vue'),
	WebInteraction: () => import('@/components/interactions/WebInteraction.vue'),
	MeetingsInteraction: () => import('@/components/interactions/MeetingsInteraction.vue'),
	CrmInteraction: () => import('@/components/interactions/CrmInteraction.vue'),
	AdsInteraction: () => import('@/components/interactions/AdsInteraction.vue')
}

export default {
	name: "Home",
	mixins: [hreflang],
	components,
	metaInfo() {
		return {
			title: this.translation.menu.about,
		}
	},
	computed: {
		...mapGetters("demo", ["interactionsTotal", "interactionsCompleted"]),
		...mapState({
			interactions: (state) => state.demo.interactions,
		}),
		isDetailsOpened: function() {
			return (
				window.innerHeight < window.innerWidth && window.innerHeight > 1000
			);
		},
		progress: function() {
			return Math.round(
				(this.interactionsCompleted / this.interactionsTotal) * 100
			);
		},
	},
	methods: {
		metatext,
		interactionComponent: function(name) {
			let component = name.slice(0, 1).toUpperCase() + name.slice(1) + "Interaction"
			if (components[component]) return component
		},
	},
	data() {
		return {};
	},
	created() {
		this.document(require("documents/en/about/about.md"), "en");
		this.document(require("documents/en/about/goal.md"), "en");

		for (let interaction in this.interactions) {
			this.document(
				require(`documents/en/interactions/${interaction}.md`),
				"en"
			);
		}
	},
};
</script>
